import { ReturnConsignment } from 'types';
import { convertTimestampToDate } from 'helpers';

export function returnConsignmentFactory(
  params: any = []
): ReturnConsignment[] {
  return params.map((param: any = {}) => {
    const {
      consignmentCode,
      customerName,
      optionsCollect,
      returnRequestStatus,
      customerCpf,
      protocol,
      createdDate,
    } = param;

    return {
      consignmentCode: consignmentCode || '',
      customerName: customerName || '',
      optionsCollect: optionsCollect || '',
      returnRequestStatus: returnRequestStatus || '',
      customerCpf: customerCpf || '',
      protocol: protocol || '',
      createdDate: convertTimestampToDate(createdDate || 0),
    };
  });
}
